import React from 'react';

export const Play = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.1 18" width="18" height="18">
            <path d="M0 1.458v15.084a1.7 1.7 0 0 0 2.6 1.223l13.72-7.542a1.357 1.357 0 0 0 0-2.461L2.6.235A1.7 1.7 0 0 0 0 1.458Z" />
        </svg>
    );
};
